export default "__VITE_ASSET__145ca3b8__"